export type SpecialtyFields = {
  Description: {
    value: string;
  };
  // EUI: {
  // 	value: String;
  // };
  // 'Search Terms': {
  // 	value: string;
  // };
  // SpecialtyRank: {
  // 	value: string;
  // };
};

export type Specialty = {
  displayName: string;
  id: string;
  name: string;
  // url: string;
  fields: SpecialtyFields;
};

export type SpecialtyFilterType = {
  description: string;
  eui: string;
  id: string;
  searchterms: Array<string>;
  superspecialty: string;
  superspecialtyid: string;
};
